import React, { useState, useEffect } from 'react';
import { previewGameStyles as styles } from '../deployToken.tailwind.js';
import Group from '../../../assets/svgs/Group.svg';
import HowItWorksModal from '../../shared/Modals/HowItWorksModal/HowItWorksModal'; // Import the modal component
import { getSportCourt } from '../../../pages/SportPage/sportPageData.js';
import { useSelector } from 'react-redux';
import { storage } from '../../../config/storage.js';
import SportCourt from '../../Sports/SportCourt.jsx';
import Spinner from '../../shared/Loaders/Spinner.jsx';
// import { buyedTokens } from './SelectionData.js';
// import { getDefaultZoneName } from '../../Sports/Courts/BasketballCourt/court.data.js';

const PreviewGame = ({ selectedTokenData, setSelectedTokenId, hasUnsavedChanges, setShowUnsavedChangesModal, setNextTokenId }) => {
  const { currentSeason } = useSelector(state => state.seasons)
  const checkSportGround = getSportCourt(currentSeason?.seasonCode)
  const { tokens } = useSelector((state) => state.deployToken);

  // State to control modal visibility
  const [modalOpen, setModalOpen] = useState(false);

  // const buyedTokens = tokens.reduce((acc, token) => {
  //   const newZoneName = getDefaultZoneName(currentSeason?.zoneCategories, token?.zoneName);

  //   if (!newZoneName) return acc; // If no matching newZoneName, skip the token
  
  //   // Check if the newZoneName already exists in the accumulator
  //   const existing = acc.find((t) => t.zoneName === newZoneName);
  //   // increment if token count if newZoneName already exists else add newZoneName and intial count 1
  //   if (existing) {
  //     existing.tokenCount += 1;
  //     if (token?._id === selectedTokenData?._id) {
  //       existing.highlighted = true;
  //     }
  //   } else {
  //     acc.push({ zoneName: newZoneName, tokenCount: 1, highlighted: token?._id === selectedTokenData?._id });
  //   }
  
  //   return acc;
  // }, []);
 
  const purchahsedTokens = tokens.map((token, key) => ({
    ...token,
    highlighted: token?._id === selectedTokenData?._id,
    onClick: () => {
      if (hasUnsavedChanges) {
        setNextTokenId(key);
        setShowUnsavedChangesModal(true);
        return;
      }
      
      setSelectedTokenId(key)
    }
  }));

  // const selectedTokenZoneName = getDefaultZoneName(currentSeason?.zoneCategories, selectedTokenData?.zoneName);
  // const selectedTokenDetails = buyedTokens?.find(token => token?.zoneName === selectedTokenZoneName);
  // const highlightedTokens = selectedTokenDetails ? [selectedTokenDetails] : [];

  //to check localStorage to see if modal has been shown earlier
  useEffect(()=>{
    const hasSeenModal= storage.fetchFromLocalStorage.howItWorksModal();
    if(!hasSeenModal){
      setModalOpen(true);
      storage.setInLocalStorage.howItWorksModal(true); //set modal as seen
    }
  },[]);

  // Functions to handle modal open and close
  const handleOpen = () => setModalOpen(true);
  const handleClose = () => setModalOpen(false);

  if(!checkSportGround) {
    return(
      <div className={styles.outerContainer} style={{ boxShadow: '0px 3px 19px 0px var(--deployTokenPageBoxShadow)' }}>
        <div className='w-full h-full flex items-center justify-center'>
          <Spinner />
        </div>
      </div>
    )
  }

  return (
    <div className={styles.outerContainer} style={{ boxShadow: '0px 3px 19px 0px var(--deployTokenPageBoxShadow)' }}>
      {/* Modal Component */}
      <HowItWorksModal isOpen={modalOpen} onClose={handleClose} />

      {/* Court Component */}
      <SportCourt
        disableModal={true}
        previewGame={true}
        showHoveredTooltip={false}
        tokensToShowOnGround={tokens}
        CourtGround={checkSportGround}
        isDeployTokenPage={true}
        purchasedTokens={purchahsedTokens}
        hideHover={true}
        // hideZoneName={true}
      />
      
      <div className={styles.groupButton} onClick={handleOpen}>
        <img src={Group} alt="Group" className={styles.groupIcon}/>
      </div>
    </div>
  );
}

export default PreviewGame